export default __webpack_public_path__ + "static/media/tombstone.ee58497c.svg";